import axios from 'axios'

const state = {
    isDownloading: false,
    devis: [],
    devisLoading: false
}

const actions = {

    /**
     * Service pour récupérer les devis.
     * @param {*} param0 
     * @returns 
     */
    getDevis({
        commit
    }) {
        commit('setDevisLoading', true)
        return new Promise((resolve, reject) => {
            axios.get('/api/devis').then(response => {
                commit('setDevis', response.data)
                commit('setDevisLoading', false)
                resolve(response)
            }).catch(error => {
                commit('setDevisLoading', false)
                reject(error)
            });
        });
    },

    /**
     * Service pour télécharger la facture.
     * @param {*} param0 
     * @param {*} devisInfo 
     * @returns 
     */
    downloadFacture({
        commit,
    }, codesDevis) {
        commit('setIsDownloading', true)
        return new Promise((resolve, reject) => {
            axios({
                url: '/api/downloadFacture',
                method: 'POST',
                responseType: 'blob',
                data: codesDevis,
                headers: {
                    'Accept': 'application/pdf',
                },
            }).then(response => {
                commit('setIsDownloading', false)
                let documentName = ''
                codesDevis.ListeCodeEnteteDevis.forEach((aCode, index) => {
                    if (index + 1 === codesDevis.ListeCodeEnteteDevis.length) {
                        documentName = documentName + aCode + '.pdf'
                    } else {
                        documentName = documentName + aCode + '-'
                    }
                })
                if (!window.navigator.msSaveOrOpenBlob) {
                    // BLOB NAVIGATOR
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url

                    link.setAttribute('download', documentName)
                    document.body.appendChild(link)
                    link.click()
                } else {
                    // BLOB FOR EXPLORER 11
                    const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), documentName)
                }
                resolve()
            }).catch(err => {
                commit('setIsDownloading', false)
                reject(err)
            })
        })
    },
}


const getters = {
    isDownloading: state => state.isDownloading,
    devis: state => state.devis,
    devisLoading: state => state.devisLoading
}

const mutations = {
    setIsDownloading(state, isDownloading) {
        state.isDownloading = isDownloading;
    },
    setDevis(state, devis) {
        state.devis = devis
    },
    setDevisLoading(state, devisLoading) {
        state.devisLoading = devisLoading
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
